import styled from 'styled-components';

/**
 * A styled-component is used as the Portal component instead of a primitive `<div/>` so that
 * we can create CSS rules that only apply to descendance of the Portal
 */
const PortalComponent = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-no8fhr-0"
})([""]);

export { PortalComponent as P };
//# sourceMappingURL=PortalComponent-BUo03SeR.js.map
